/*
  !IMPORTANT!: This file will be deleted in the future!
  If you want to use this functionality, please rather turn your *.vue file into a composition API and directly use the `useEntity` composable instead.
  This file is only kept for backwards compatibility for old *.vue files that are still using options API and mixins.

  If you want to change the branding functionality, please do it in this mixin AND the composable!
*/

const onboardingMixin = {
  computed: {
    isOnboarding () {
      return this.$route.meta?.onboarding
    },
    isManualStudentCreationEnabled() {
      return this.$me?.school?.properties['users.students.create.enabled']
    }
  }
}

export default onboardingMixin
